import { createFeature, createReducer, on } from '@ngrx/store';
import { YearOfStudy } from '../../services/model/year-of-study';
import { ReferenceDataActions } from '../actions/reference-data.actions';
import { ReferenceDataEstablishment } from '../../services/model/reference-data';

export interface ReferenceDataState {
  yearOfStudy: YearOfStudy[];
  establishments: ReferenceDataEstablishment[];
}

export const initialReferenceDataState: ReferenceDataState = {
  yearOfStudy: [],
  establishments: [],
};

export const referenceDataFeature = createFeature({
  name: 'referenceData',
  reducer: createReducer(
    initialReferenceDataState,
    on(ReferenceDataActions.yearsOfStudyLoaded, (state, { yearOfStudy }) => ({
      ...state,
      yearOfStudy: [...yearOfStudy],
    })),
    on(ReferenceDataActions.establishmentsLoaded, (state, { establishments }) => ({
      ...state,
      establishments: [...establishments],
    })),
  ),
});
